// TSS vite/04 §"Endpoint paths". baseURL ya incluye /api/v1.
// Contrato: api-reference/admin-notifications.md (Tier 110, 0121).
// OJO: NO existe GET /admin/notification-templates/:code — solo list, POST,
// PATCH :code y :code/test-send. El detalle se resuelve desde la lista.

export const templatePaths = {
    list:     ()     => 'admin/notification-templates',
    detail:   (code) => `admin/notification-templates/${encodeURIComponent(code)}`,
    testSend: (code) => `admin/notification-templates/${encodeURIComponent(code)}/test-send`,
};
